import React from "react";

const Inicio = () => {
  return (
    <div className="flex justify-center items-center min-h-screen bg-[#081b29]">
      <img
        src="/img/monytorlogoa.png"
        alt="Logo"
        className="w-1/3 max-w-xs md:max-w-sm lg:max-w-md xl:max-w-lg"
      />
    </div>
  );
};

export default Inicio;
